module.exports = __webpack_public_path__ + "static/media/premio-ana-2023.3d483780.png";